import React from 'react';
import styled from 'styled-components';

import palette from '../../../../styled-components/palette';
import { type MissionFormatRule } from '../../types/state/missions';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  gap: 1em;
`;

const RuleWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const RuleTitle = styled.div`
  font-size: 110%;
  font-weight: bold;

  &:first-letter {
    text-transform: uppercase;
  }
`;

const RuleContentList = styled.div`
  margin-top: 0.33em;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.33em;
`;

const RuleItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.33em;
`;

const RuleItemBulletPoint = styled.div`
  margin-top: 0.4em;
  height: 0.4em;
  width: 0.4em;
  border-radius: 9999px;
  flex-shrink: 0;

  background-color: ${palette.redwinamax500};
`;

const RuleItemLabel = styled.div`
  font-size: 90%;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export type MissionDetailsRuleListProps = {
  missionId: number;
  formatRules: Array<MissionFormatRule>;
};

const MissionDetailsRuleList = ({ missionId, formatRules }: MissionDetailsRuleListProps) => {
  return (
    <Wrapper>
      {formatRules.map((rule, key) => (
        <>
          <RuleWrapper key={`mission-${missionId}-rule-${key}`}>
            <RuleTitle>{rule.title}</RuleTitle>
            <RuleContentList>
              {rule.rules.map((item, itemKey) => (
                <RuleItem key={`mission-${missionId}-rule-${key}-${itemKey}`}>
                  {rule.rules.length > 1 ? <RuleItemBulletPoint /> : null}
                  <RuleItemLabel>{item}</RuleItemLabel>
                </RuleItem>
              ))}
            </RuleContentList>
          </RuleWrapper>
        </>
      ))}
    </Wrapper>
  );
};

export default MissionDetailsRuleList;
